"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_image_1 = require("@hotelplan/components.common.image");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const TripAdvisorRaiting_1 = __importDefault(require("./TripAdvisorRaiting"));
const TripAdvisorInfoWrap = styled_components_1.default.div(({ theme: { media } }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    '> .-rating': {
        display: 'flex',
        alignItems: 'center',
        height: '18px',
        [media.tablet]: {
            height: '27px',
        },
    },
    [media.tablet]: {
        alignItems: 'center',
    },
}));
const TripadvisorLogoOwl = (0, styled_components_1.default)(components_common_image_1.Image).attrs({
    src: '/images/TripadvisorLogoOwl.svg',
    alt: `Tripadvisor Logo`,
    resized: [],
    lazy: false,
})(({ size, theme }) => { var _a; return (size ? ((_a = theme.tripAdvisor) === null || _a === void 0 ? void 0 : _a[size]).image : {}); }, (0, util_theme_sxc_1.sx2CssThemeFn)({
    mr: [2, '12px'],
}));
const TripAdvisorInfoNumber = styled_components_1.default.span(({ size, theme }) => { var _a; return (size ? ((_a = theme.tripAdvisor) === null || _a === void 0 ? void 0 : _a[size]).text : {}); }, ({ theme: { space } }) => ({
    marginRight: space[1],
}));
const TripAdvisorInfo = ({ rating, reviewCount, label, size = 'small', className, }) => {
    return (react_1.default.createElement(TripAdvisorInfoWrap, { className: className },
        react_1.default.createElement("div", { className: "-rating" },
            react_1.default.createElement(TripadvisorLogoOwl, { className: "tripadvisorLogo", size: size }),
            react_1.default.createElement(TripAdvisorRaiting_1.default, { rating: rating, size: size })),
        reviewCount > 0 && (react_1.default.createElement("div", { className: "tripAdvisorInfoText" },
            react_1.default.createElement(TripAdvisorInfoNumber, { className: "tripAdvisorInfoNumber" }, reviewCount ? `(${reviewCount})` : ''),
            react_1.default.createElement("span", null, label || '')))));
};
exports.default = TripAdvisorInfo;
//# sourceMappingURL=TripAdvisorInfo.js.map